export default __webpack_public_path__ + "static/media/droplet.fc72df95.png";